import React from 'react';
import { Grid, List, ListItem, ListItemText,} from '@material-ui/core';
// import Ws from '../../providers/Ws'


export default class ListaChestionare extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
 
}
    }

     componentDidMount(){
    }
     render() { 
       return (
          <div>
            <Grid  container style={{borderRadius:16, width:this.props.width, paddingLeft:10}}>
            <div style={{width:'100%'}}>
            {/* <Button style={{display:this.props.goBack === true ? 'block': 'none'}} className='chestionare-appbar-buttons' onClick={this.props.goBackFunc} >
                <i style={{verticalAlign:'bottom'}} className='material-icons'>keyboard_arrow_left</i>
                <span className='chestionare-appbar-button-text'>Inapoi</span>
            </Button> */}

            </div>
           
           
                    {/* <h4  style={{width:'100%', marginBottom:0}} className='chestionare-title'>{this.props.title}</h4> */}
                        <Grid item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>  
                        {this.props.listaChestionare.length > 0 &&
                        
                                <List  >
                                {
                                    this.props.listaChestionare.map((c,idx)=>{
                                        return(
                                        <LiListaChestionare isDragable={this.props.isDragable} dragStart={this.props.dragStart} textAlign={this.props.textAlign} fontSize={this.props.fontSize} key={'chestionar' + idx} chestionar={c} onClick={this.props.goToChestionar} />
                                        )
                                    })
                                }
                                    
                            </List>
                        }
                          

                            {this.props.listaChestionare.length === 0 && this.props.scop ==='template'&&
                                <h3 style={{fontWeight:400}}>Nu exista chestionare template, pentru a adauga un chestionar template apasati pe butonul <b style={{color:'red'}}>"Foloseste ca template"</b>, din pagina de constructie al chestionarului !</h3>
                            }
                              {this.props.listaChestionare.length === 0 && this.props.scop ==='raport'&&
                                <h3 style={{fontWeight:400}}> Nu aveti chestionare in curs de completare sau completate, din acest motiv nu exista rapoarte. Pentru a crea un chestionar nou va rugam dati click pe <span style={{color:'red'}}>Chestionare</span>  sau <span style={{color:'red'}}>Home</span> din meniul din stanga.</h3>
                            }
                           
                        </Grid>     
                    </Grid> 
         </div>
        );
       }
}


class LiListaChestionare extends React.Component{
 

  

  

  getInfoChestionar = ()=>{
    this.props.onClick(this.props.chestionar)
  }

  render() { 
    return (
         
        <div>
           {this.props.isDragable &&
         <ListItem  button style={{padding:'5px 0 5px 0'}} >
         <ListItemText  draggable onDragStart={()=>{this.props.dragStart(this.props.chestionar)}} onClick={this.getInfoChestionar} primary={<h3 style={{fontSize:this.props.fontSize, textAlign:this.props.textAlign}} className='chestionare-list-text'>
        {this.props.chestionar.nume}
                                 </h3>} />
                  
     </ListItem>}

     {!this.props.isDragable &&
    
    <ListItem  button  style={{padding:'5px 0 5px 0'}} >
         <ListItemText  onClick={this.getInfoChestionar} primary={<h3 style={{fontSize:this.props.fontSize, textAlign:this.props.textAlign, padding:0}} className='chestionare-list-text'>
        {this.props.chestionar.nume}
                                 </h3>} />
                  
     </ListItem>}
       
    {/* <Divider className="chestionare-divider"/> */}
    </div>
      )
}
}

























// import React from 'react';
// import { Grid, List, ListItem, ListItemText, Divider } from '@material-ui/core';
// import Ws from '../../providers/Ws';


// export default class ListaChestionare extends React.Component {
//     constructor(props) {
//       super(props);
//        this.state = {
 
// }
//     }

//      componentDidMount(){
//     }
//      render() { 
//        return (
//           <div>
//             <Grid container className="container" style={{borderRadius:16}}>
//                         <Grid item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>  
//                             <List className="chestionare-common-list" >
//                                 {
//                                     this.props.listaChestionare.map((c,idx)=>{
//                                         return(
//                                            <LiListaChestionare key={idx} chestionar={c} onClick={this.props.goToChestionar} />
//                                         )
//                                     })
//                                 }
//                             </List>
                           
//                         </Grid>     
//                     </Grid> 
//          </div>
//         );
//        }
// }


// class LiListaChestionare extends React.Component{
//   constructor(props){
//     super(props);
  
//   }

  

  

//   getInfoChestionar = ()=>{
//     this.props.onClick(this.props.chestionar)
//   }

//   render() { 
//     return (
//         <div>
//         <ListItem  button  >
//         <ListItemText onClick={this.getInfoChestionar} primary={<h3 className='chestionare-list-text'>
//         <i className='material-icons chestionare-list-icons'>event_note</i>{this.props.chestionar.nume}
//                                 </h3>} />
                 
//     </ListItem>
//     <Divider className="crm-divider"/>
//     </div>
//       )
// }
// }

